export const CART_ADD_ITEM = 'CART_ADD_ITEM'
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM'
export const CART_ACTIVATE_GRANT = 'CART_ACTIVATE_GRANT'
export const CART_DEACTIVATE_GRANT = 'CART_DEACTIVATE_GRANT'
export const CART_APPLY_CERTIFICATE_FEE = 'CART_APPLY_CERTIFICATE_FEE'
export const CART_SAVE_SHIPPING_ADDRESS = 'CART_SAVE_SHIPPING_ADDRESS'
export const CART_SAVE_PAYMENT_METHOD = 'CART_SAVE_PAYMENT_METHOD'
export const CART_RESET = 'CART_RESET'